import AdvanceConsumerReportPermissionScreen from 'features/advance/screens/lightning/AdvanceConsumerReportPermission/AdvanceConsumerReportPermission';

const CraUpgradePage = () => {
  return <AdvanceConsumerReportPermissionScreen />;
};

export default CraUpgradePage;
